const input = {
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    email: 'E-mail',
    phone_number: 'Numer telefonu',
    student_number: 'Numer studenta',
    registration_number: 'Numer rejestracyjny',
    student_identifier_legend: 'Zaloguj się za pomocą',
    confirm_password: 'Potwierdź hasło',
    search_region_code: 'Kod regionu wyszukiwania',
    backup_code: 'Kod kopii zapasowej',
    code: 'Kod',
    label_with_optional: '{{label}} (Opcjonalne)',
};
export default Object.freeze(input);
